import { useTranslation } from 'react-i18next';
import { Button, Card } from '@/design-system';
import { errorText } from './errorText';
import s from './PageHeader.module.css';

/** A failed query: the error's i18n message (from the API error body) and a retry button. */
export function LoadError({ error, onRetry }: { error: unknown; onRetry: () => void }) {
  const { t } = useTranslation('common');
  const text = errorText(error, t);
  return (
    <Card padding={24} className={s.loadError} role="alert">
      <span className={s.naTitle}>{t('errors.load_failed')}</span>
      <span className={s.naText}>{text}</span>
      <Button variant="secondary" size={36} icon="refresh-cw" iconSize={14} onClick={onRetry}>
        {t('errors.retry')}
      </Button>
    </Card>
  );
}
